"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "COUPON_CURRENCY_SYMBOL", {
  enumerable: true,
  get: function () {
    return _couponOffer.COUPON_CURRENCY_SYMBOL;
  }
});
Object.defineProperty(exports, "COUPON_EVENTS", {
  enumerable: true,
  get: function () {
    return _couponAnalytics.COUPON_EVENTS;
  }
});
Object.defineProperty(exports, "COUPON_SERVICE", {
  enumerable: true,
  get: function () {
    return _couponAnalytics.COUPON_SERVICE;
  }
});
Object.defineProperty(exports, "getCouponEvents", {
  enumerable: true,
  get: function () {
    return _couponAnalytics.getCouponEvents;
  }
});
Object.defineProperty(exports, "getCouponOffAmount", {
  enumerable: true,
  get: function () {
    return _couponOffer.getCouponOffAmount;
  }
});
Object.defineProperty(exports, "getCouponSavingsAmount", {
  enumerable: true,
  get: function () {
    return _couponOffer.getCouponSavingsAmount;
  }
});
var _couponOffer = require("./couponOffer");
var _couponAnalytics = require("./couponAnalytics");